import { createStore } from "owa-satcheljs";
import type { IFeedbackInitOptions } from "../schema/FeedbackTypes";

export interface FeedbackDialogState {
    isOpen: boolean;
    targetWindow?: Window;
    feedbackInitOptions?: IFeedbackInitOptions;
    mergedOptions?: IFeedbackInitOptions;
    isLoading: boolean;
}

const initialState: FeedbackDialogState = {
    isOpen: false,
    targetWindow: undefined,
    feedbackInitOptions: undefined,
    mergedOptions: undefined,
    isLoading: false,
};

export const getStore: () => FeedbackDialogState = createStore<FeedbackDialogState>("feedbackDialog", initialState);
